/**
 * フロントエンド専用モード: 認証API不要のため空のsaga
 */
export default function* authSaga() {
  // ローカルストレージモードでは認証APIを呼ばない
}
